import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import CustomerService from "../../services/CustomerService";
import { toast } from "react-toastify";
import "./EditCustomerModal.css";

const EditCustomerModal = ({ showModal, handleClose, customerData = {}, onCustomerUpdated }) => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    address: "",
  });

  useEffect(() => {
    if (customerData && Object.keys(customerData).length > 0) {
      setFormData({
        firstName: customerData["First Name"] || "",
        lastName: customerData["Last Name"] || "",
        email: customerData.Email || "",
        phone: customerData.Phone || "",
        address: customerData.Address || "",
      });
    }
  }, [customerData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const updateCustomer = async () => {
    try {
      if (!customerData || !customerData.ID || Object.keys(customerData).length === 0) {
        throw new Error("Invalid customer data");
      }
      
      const response = await CustomerService.update(customerData.ID, formData); 
      toast.success(response?.data?.message || "Customer updated successfully", {
        autoClose: 2000,
      });
      onCustomerUpdated(); 
      handleClose();
    } catch (error) {
      console.error("Failed to update customer:", error);
      toast.error("Failed to update customer");
    }
  };

  return (
    <Modal 
      className="add-customer-modal" 
      show={showModal && customerData && Object.keys(customerData).length > 0} 
      onHide={handleClose}
    >
      <Modal.Header closeButton>
        <Modal.Title className="title">Edit Customer</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form>
          <div className="form-group">
            <label>First Name</label>
            <input
              type="text"
              name="firstName"
              value={formData.firstName}
              onChange={handleInputChange}
              placeholder="First Name"
              required
            />
          </div>
          <div className="form-group">
            <label>Last Name</label>
            <input
              type="text"
              name="lastName"
              value={formData.lastName}
              onChange={handleInputChange}
              placeholder="Last Name"
              required
            />
          </div>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              placeholder="Email"
              required
            />
          </div>
          <div className="form-group">
            <label>Phone</label>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleInputChange}
              placeholder="Phone Number"
              required
            />
          </div>
          <div className="form-group">
            <label>Address</label>
            <input
              type="text"
              name="address"
              value={formData.address}
              onChange={handleInputChange}
              placeholder="Address"
              required
            />
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex justify-content-end w-100">
          <Button variant="primary" onClick={updateCustomer} className="w-100">
            Save
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default EditCustomerModal;
